<template>
    <div :id="member.id" class="team-member">
        <div class="team-member__email">{{ member.id }}</div>
        <Tag
            v-if="entityType !== 'client' && member.accessViaScope === 'client'"
            class="team-member__scope"
            type="border"
        >
            Client Team
        </Tag>
        <div v-if="canRemove(member.id)" class="revoke" @click="$emit('remove')">
            <Icon type="ios-close" />
        </div>
        <div class="clear" />
        <div class="team-member__access">{{ member.role.name }}</div>
    </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";

import { USER_ACTIONS } from "shared-utils/enums/user";

import type { UserWithScope } from "@/types/types";
import { userCan } from "@/services/Auth";

export default defineComponent({
    name: "TeamMember",
    props: {
        member: {
            type: Object as PropType<UserWithScope>,
            required: true
        },
        entityType: {
            type: String as PropType<"campaign" | "client">,
            required: true
        }
    },

    emits: ["remove"],

    computed: {
        userId() {
            return this.$store.state.auth.me?.id;
        }
    },

    methods: {
        canRemove(memberId: string) {
            // allowed to remove users
            return (
                userCan(USER_ACTIONS.canManageUsers) &&
                // can't remove self
                this.userId !== memberId &&
                // can't remove client level users from a campaign
                (this.entityType !== "campaign" || this.member.accessViaScope === "campaign")
            );
        }
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;

.team-member {
    margin-bottom: 0.5rem;

    .team-member__email {
        font-size: 1rem;
        font-weight: bold;
        float: left;
    }

    .team-member__access {
        text-transform: capitalize;
    }

    .team-member__scope {
        float: right;
        background: transparent !important;

        .ivu-tag-text {
            color: $info-color !important;
        }

        &.ivu-tag-border {
            border-color: $info-color;
        }
    }

    .revoke {
        float: right;
        font-size: 0.8rem;
        padding-top: 5px;
        cursor: pointer;
    }

    .clear {
        clear: both;
    }
}
</style>
